import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ServicesRoutingModule } from './services-routing.module';
import { ClarityModule } from '@clr/angular';
import { VcaCommonModule } from '../../../common';
import ServicesMain from './services-main.component';

import { DynamicDPSModule } from '../dataprotection/dynamic-dps/dynamic-dps.module';
import { DynamicComputeModule } from '../compute/dynamic-compute/dynamic-compute.module';
import { DisasterRecoveryModule } from '../disaster-recovery/disaster-recovery.module';
import { HcspDashboardModule } from '../hcsp-dashboard/hcsp-dashboard.module';
import { MigrationModule } from '../migration/migration.module';
import { NetworkExtensionModule } from '../network-extension/network-extension.module';
import { NetworkExtensionModule2 } from '../network-extension2/network-extension.module2';

import { ResizableModule } from 'angular-resizable-element';
import { NetworkingModule } from '../../modules/networking/networking-vc/networking.module';
import { NetworkingVcdModule } from '../../modules/networking/networking-vcd/networking-vcd.module';
import AddEditImportNetworkDialog from '../../modules/networking/networking-vc/networks/import-network/add-edit-import-network-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ServicesRoutingModule,
        VcaCommonModule,
        ClarityModule.forRoot(),
        DynamicDPSModule.forRoot(),
        DynamicComputeModule.forRoot(),
        DisasterRecoveryModule,
        NetworkingModule,
        NetworkingVcdModule,
        ResizableModule,
        HcspDashboardModule,
        MigrationModule,
        NetworkExtensionModule,
        NetworkExtensionModule2
    ],
    declarations: [
        ServicesMain
    ],
    exports: [AddEditImportNetworkDialog]
})
export class ServicesModule {
}



// WEBPACK FOOTER //
// ./src/app/components/services-main/services.module.ts